import { Action } from '@ngrx/store'

export const GET_IMAGE = '[GET_IMAGE] GetImage';
export const SET_IMAGE = '[SET_IMAGE] SetImage';

export class GetImage implements Action {
    readonly type = GET_IMAGE

    constructor(public payload: any) {}
}

export class SetImage implements Action {
    readonly type = SET_IMAGE

    constructor(public payload: any) {}
}

export type Actions = GetImage | SetImage